const tokens = {
    blue100: '#edf6ff',
    blue1000: '#001366',
    blue200: '#cce0ff',
    blue300: '#9cc5ff',
    blue400: '#73a9ff',
    blue500: '#4a89ff',
    blue600: '#2166ff',
    blue700: '#114ad9',
    blue800: '#0531b3',
    blue900: '#001e8c',
    cyan100: '#e4feff',
    cyan1000: '#00323d',
    cyan200: '#befafb',
    cyan300: '#8af0f7',
    cyan400: '#52dae3',
    cyan500: '#28c4d3',
    cyan600: '#09b0c3',
    cyan700: '#0995a8',
    cyan800: '#0a7b8d',
    cyan900: '#085765',
    gold100: '#fffbe6',
    gold1000: '#613400',
    gold200: '#fff1b8',
    gold300: '#ffe58f',
    gold400: '#ffd666',
    gold500: '#ffc53d',
    gold600: '#faad14',
    gold700: '#d48806',
    gold800: '#ad6800',
    gold900: '#874d00',
    green100: '#ecf7ec',
    green1000: '#113c18',
    green200: '#d0f0d1',
    green300: '#a4e0a7',
    green400: '#7dd182',
    green500: '#5ac262',
    green600: '#3bb346',
    green700: '#30953b',
    green800: '#25772f',
    green900: '#1b5924',
    grey100: '#ffffff',
    grey1000: '#333d4e',
    grey1100: '#272e3b',
    grey1200: '#1d2129',
    grey200: '#f7f8fa',
    grey300: '#f0f3f8',
    grey400: '#e5eaf0',
    grey500: '#ccd3df',
    grey600: '#b4bbc7',
    grey700: '#86909c',
    grey800: '#6b7785',
    grey900: '#4e5969',
    indigo100: '#edf2ff',
    indigo1000: '#171d63',
    indigo200: '#d2dbfb',
    indigo300: '#adbbf1',
    indigo400: '#7f93e8',
    indigo500: '#566cd9',
    indigo600: '#4357c7',
    indigo700: '#3445b5',
    indigo800: '#2534a2',
    indigo900: '#1f2878',
    lightBlue100: '#e9f7fd',
    lightBlue1000: '#00355f',
    lightBlue200: '#cbefff',
    lightBlue300: '#99deff',
    lightBlue400: '#64caff',
    lightBlue500: '#30b4fe',
    lightBlue600: '#0095ee',
    lightBlue700: '#0181d2',
    lightBlue800: '#0063a7',
    lightBlue900: '#004b83',
    lime100: '#f2fae6',
    lime1000: '#2f4600',
    lime200: '#d9f7be',
    lime300: '#cbed8e',
    lime400: '#b7e35b',
    lime500: '#a7da2c',
    lime600: '#9bd100',
    lime700: '#7eae00',
    lime800: '#638b00',
    lime900: '#486800',
    pink100: '#fdecef',
    pink1000: '#5a012b',
    pink200: '#fbcfd8',
    pink300: '#f6a0b5',
    pink400: '#f27396',
    pink500: '#ed487b',
    pink600: '#e91e63',
    pink700: '#c51356',
    pink800: '#a20b48',
    pink900: '#7e053a',
    purple100: '#f7e9f7',
    purple1000: '#490a61',
    purple200: '#efcaf0',
    purple300: '#dd9be0',
    purple400: '#c96fd1',
    purple500: '#b449c2',
    purple600: '#9e28b3',
    purple700: '#871e9e',
    purple800: '#71168a',
    purple900: '#5c0f75',
    red100: '#ffeceb',
    red200: '#ffd5d2',
    red300: '#fd9891',
    red400: '#f87168',
    red500: '#f15b50',
    red600: '#e2483d',
    red700: '#c9372c',
    red800: '#ae2e24',
    red900: '#8e0805',
    redRed1000: '#6a0103',
    violet100: '#f3edf9',
    violet1000: '#281475',
    violet200: '#e2d1f4',
    violet300: '#cdadf6',
    violet400: '#b184f0',
    violet500: '#8d5ae1',
    violet600: '#6a3ac7',
    violet700: '#572fb3',
    violet800: '#46259e',
    violet900: '#361c8a',
    weetColorBackgroundBrandDefaultClick: '#114ad9',
    weetColorBackgroundBrandDefaultDisable: '#9cc5ff',
    weetColorBackgroundBrandDefaultHover: '#4a89ff',
    weetColorBackgroundBrandDefaultNormal: '#2166ff',
    weetColorBackgroundBrandSelect: '#2166ff',
    weetColorBackgroundBrandSubtle: '#9cc5ff',
    weetColorBackgroundBrandSubtler: '#cce0ff',
    weetColorBackgroundBrandSubtlest: '#edf6ff',
    weetColorBackgroundDangerDefaultClick: '#c9372c',
    weetColorBackgroundDangerDefaultDisabled: '#f87168',
    weetColorBackgroundDangerDefaultHover: '#f15b50',
    weetColorBackgroundDangerDefaultNormal: '#e2483d',
    weetColorBackgroundDangerSubtleDefault: '#fd9891',
    weetColorBackgroundDangerSubtler: '#ffd5d2',
    weetColorBackgroundDangerSubtlest: '#ffeceb',
    weetColorBackgroundNeutralBold: '#ccd3df',
    weetColorBackgroundNeutralBolderDefault: '#b4bbc7',
    weetColorBackgroundNeutralSubler: '#f0f3f8',
    weetColorBackgroundNeutralSublest: '#f7f8fa',
    weetColorBackgroundNeutralSubtle: '#e5eaf0',
    weetColorBackgroundNeutralWhite: '#ffffff',
    weetColorBackgroundSuccessDefaultClick: '#3bb346',
    weetColorBackgroundSuccessDefaultDefault: '#5ac262',
    weetColorBackgroundSuccessDefaultDisabled: '#a4e0a7',
    weetColorBackgroundSuccessDefaultHover: '#7dd182',
    weetColorBackgroundSuccessSubtleDefault: '#a4e0a7',
    weetColorBackgroundSuccessSubtler: '#d0f0d1',
    weetColorBackgroundSuccessSubtlest: '#ecf7ec',
    weetColorBackgroundWarningDefaultClick: '#d48806',
    weetColorBackgroundWarningDefaultDisabled: '#ffd666',
    weetColorBackgroundWarningDefaultHover: '#ffc53d',
    weetColorBackgroundWarningDefaultNormal: '#faad14',
    weetColorBackgroundWarningSubtleDefault: '#ffe58f',
    weetColorBackgroundWarningSubtler: '#fff1b8',
    weetColorBackgroundWarningSubtlest: '#fffbe6',
    weetColorBlanketSubtle: '#1d212966',
    weetColorBlanketSubtler: '#1d212940',
    weetColorBlanketSubtlest: '#ffffffcc',
    weetColorBorderBrandClick: '#114ad9',
    weetColorBorderBrandDisable: '#9cc5ff',
    weetColorBorderBrandHover: '#4a89ff',
    weetColorBorderBrandNormal: '#2166ff',
    weetColorBorderDangerClick: '#c9372c',
    weetColorBorderDangerDisable: '#f87168',
    weetColorBorderDangerHover: '#f15b50',
    weetColorBorderDangerNormal: '#e2483d',
    weetColorBorderNeutralSubtle: '#ccd3df',
    weetColorBorderNeutralSubtler: '#e5eaf0',
    weetColorBorderNeutralSubtlest: '#f0f3f8',
    weetColorBorderSelect: '#2166ff',
    weetColorBorderSuccessClick: '#30953b',
    weetColorBorderSuccessDisable: '#7dd182',
    weetColorBorderSuccessNormal: '#3bb346',
    weetColorBorderWarningClick: '#d48806',
    weetColorBorderWarningDisable: '#ffd666',
    weetColorBorderWarningNormal: '#faad14',
    weetColorDividerBold: '#e5eaf0',
    weetColorDividerBolder: '#ccd3df',
    weetColorDividerDefault: '#f0f3f8',
    weetColorDividerSubtle: '#f7f8fa',
    weetColorIconBrandClick: '#114ad9',
    weetColorIconBrandDisable: '#9cc5ff',
    weetColorIconBrandHover: '#4a89ff',
    weetColorIconBrandNormal: '#2166ff',
    weetColorIconBrandSelect: '#2166ff',
    weetColorIconDangerClick: '#c9372c',
    weetColorIconDangerDisable: '#f87168',
    weetColorIconDangerHover: '#f15b50',
    weetColorIconDangerNormal: '#e2483d',
    weetColorIconInverse: '#ffffff',
    weetColorIconSubtleClick: '#86909c',
    weetColorIconSubtleDisable: '#e5eaf0',
    weetColorIconSubtleHover: '#ccd3df',
    weetColorIconSubtleNormal: '#b4bbc7',
    weetColorIconSuccessClick: '#30953b',
    weetColorIconSuccessDisable: '#a4e0a7',
    weetColorIconSuccessHover: '#7dd182',
    weetColorIconSuccessNormal: '#5ac262',
    weetColorIconWarningClick: '#d48806',
    weetColorIconWarningDisable: '#ffd666',
    weetColorIconWarningHover: '#ffc53d',
    weetColorIconWarningNormal: '#faad14',
    weetColorTagBlueLight: '#4a89ff26',
    weetColorTagBlueSolid: '#4a89ff',
    weetColorTagBlueText: '#001e8c',
    weetColorTagBlueTextInverse: '#ffffff',
    weetColorTagCyanLight: '#28c4d326',
    weetColorTagCyanSolid: '#28c4d3',
    weetColorTagCyanText: '#085765',
    weetColorTagCyanTextInverse: '#ffffff',
    weetColorTagGoldLight: '#ffc53d26',
    weetColorTagGoldSolid: '#ffc53d',
    weetColorTagGoldText: '#874d00',
    weetColorTagGoldTextInverse: '#ffffff',
    weetColorTagGreenLight: '#5ac26226',
    weetColorTagGreenSolid: '#5ac262',
    weetColorTagGreenText: '#1b5924',
    weetColorTagGreenTextInverse: '#ffffff',
    weetColorTagGreyLightClick: '#ccd3df',
    weetColorTagGreyLightDisable: '#f7f8fa',
    weetColorTagGreyLightHover: '#f7f8fa',
    weetColorTagGreyLightNormal: '#f0f3f8',
    weetColorTagGreySolid: '#86909c',
    weetColorTagGreyText: '#272e3b',
    weetColorTagGreyTextInverse: '#ffffff',
    weetColorTagIndigoLight: '#566cd926',
    weetColorTagIndigoSolid: '#566cd9',
    weetColorTagIndigoText: '#1f2878',
    weetColorTagIndigoTextInverse: '#ffffff',
    weetColorTagLightBlueLight: '#30b4fe26',
    weetColorTagLightBlueSolid: '#30b4fe',
    weetColorTagLightBlueText: '#004b83',
    weetColorTagLightBlueTextInverse: '#ffffff',
    weetColorTagLimeLight: '#9bd10026',
    weetColorTagLimeSolid: '#a7da2c',
    weetColorTagLimeText: '#486800',
    weetColorTagLimeTextInverse: '#ffffff',
    weetColorTagPinkLight: '#ed487b26',
    weetColorTagPinkSolid: '#ed487b',
    weetColorTagPinkText: '#7e053a',
    weetColorTagPinkTextInverse: '#ffffff',
    weetColorTagPurpleLight: '#b449c226',
    weetColorTagPurpleSolid: '#b449c2',
    weetColorTagPurpleText: '#5c0f75',
    weetColorTagPurpleTextInverse: '#ffffff',
    weetColorTagRedLight: '#f15b5026',
    weetColorTagRedSolid: '#f15b50',
    weetColorTagRedText: '#8e0805',
    weetColorTagRedTextInverse: '#ffffff',
    weetColorTagVioletLight: '#8d5ae126',
    weetColorTagVioletSolid: '#8d5ae1',
    weetColorTagVioletText: '#361c8a',
    weetColorTagVioletTextInverse: '#ffffff',
    weetColorTagYellowLight: '#fbda3226',
    weetColorTagYellowSolid: '#fbda32',
    weetColorTagYellowText: '#7d6a00',
    weetColorTagYellowTextInverse: '#ffffff',
    weetColorTextBrandClick: '#114ad9',
    weetColorTextBrandDisable: '#9cc5ff',
    weetColorTextBrandHover: '#4a89ff',
    weetColorTextBrandNormal: '#2166ff',
    weetColorTextDangerClick: '#c9372c',
    weetColorTextDangerDisable: '#f87168',
    weetColorTextDangerHover: '#f15b50',
    weetColorTextDangerNormal: '#e2483d',
    weetColorTextDisable: '#b4bbc7',
    weetColorTextInverse: '#ffffff',
    weetColorTextSelect: '#2166ff',
    weetColorTextSubtle: '#4e5969',
    weetColorTextSubtler: '#86909c',
    weetColorTextSubtlest: '#b4bbc7',
    weetColorTextSuccessClick: '#30953b',
    weetColorTextSuccessDisable: '#7dd182',
    weetColorTextSuccessHover: '#5ac262',
    weetColorTextSuccessNormal: '#3bb346',
    weetColorTextWarningClick: '#d48806',
    weetColorTextWarningDisable: '#ffd666',
    weetColorTextWarningHover: '#ffc53d',
    weetColorTextWarningNormal: '#faad14',
    weetRadiusFull: '9999px',
    weetRadiusLarge: '8px',
    weetRadiusMedium: '6px',
    weetRadiusSmall: '4px',
    weetRadiusXlarge: '12px',
    weetRadiusXsmall: '3px',
    weetSizeIconLarge: '20px',
    weetSizeIconMedium: '16px',
    weetSizeIconSmall: '12px',
    weetSizeIconSmPlus: '14px',
    weetSizeIconXlarge: '24px',
    weetSizeIconXsmall: '8px',
    weetSizeIconXxlarge: '32px',
    weetSpace0: '0px',
    weetSpace025: '2px',
    weetSpace050: '4px',
    weetSpace075: '6px',
    weetSpace100: '8px',
    weetSpace125: '10px',
    weetSpace150: '12px',
    weetSpace200: '16px',
    weetSpace250: '20px',
    weetSpace300: '24px',
    weetSpace400: '32px',
    weetSpace500: '36px',
    weetSpace600: '40px',
    yellow100: '#fffdea',
    yellow1000: '#534800',
    yellow200: '#fefbcb',
    yellow300: '#fdf398',
    yellow400: '#fce865',
    yellow500: '#fbda32',
    yellow600: '#fac800',
    yellow700: '#d0aa00',
    yellow800: '#a78b00',
    yellow900: '#7d6a00',
    fontSize10: '0px',
    fontSize12: '12px',
    fontSize13: '13px',
    fontSize14: '14px',
    fontSize16: '16px',
    fontSize18: '18px',
    fontSize20: '20px',
    fontSize24: '24px',
    fontSize32: '32px',
    fontSize40: '40px',
    fontWeight400: '400',
    fontWeight500: '500',
    fontWeight600: '600',
    lineHeight20: '20',
    lineHeight22: '22',
    lineHeight24: '24',
    lineHeight26: '26',
    lineHeight28: '28',
    lineHeight32: '32',
    lineHeight36: '36',
    lineHeight40: '40',
    lineHeight44: '44',
    lineHeight48: '48',
    lineHeight52: '52',
    lineHeight56: '56',
    lineHeight60: '60',
    weetColorBackgroundDangerDefaultDisable: '#f87168',
    weetColorBackgroundDangerSubtle: '#fd9891',
    weetColorBackgroundNeutralBolder: '#b4bbc7',
    weetColorBackgroundSuccessDefaultDisable: '#a4e0a7',
    weetColorBackgroundSuccessDefaultNormal: '#5ac262',
    weetColorBackgroundSuccessSubtle: '#a4e0a7',
    weetColorBackgroundWarningDefaultDisable: '#ffd666',
    weetColorBackgroundWarningSubtle: '#ffe58f',
    weetColorBorderInverse: '#ffffff',
    weetColorBorderSuccessHover: '#5ac262',
    weetColorBorderWarningHover: '#ffc53d',
    weetColorIconDefaultClick: '#333d4e',
    weetColorIconDefaultDisable: '#ccd3df',
    weetColorIconDefaultHover: '#6b7785',
    weetColorIconDefaultNormal: '#4e5969',
    weetColorTagGreenText2: '#1b5924',
    weetColorTextDefault: '#1d2129',
    weetRadiusNone: '0px',
    weetTypographyFontFamilyBody: 'PingFang SC',
    weetTypographyFontFamilyHeading: 'PingFang SC',
    weetTypographyFontFamilyMetric: 'Banana Pie',
    weetTypographyFontSizeBodyL: '16px',
    weetTypographyFontSizeBodyM: '14px',
    weetTypographyFontSizeBodyS: '13px',
    weetTypographyFontSizeBodyXs: '12px',
    weetTypographyFontSizeHeadingL: '18px',
    weetTypographyFontSizeHeadingM: '16px',
    weetTypographyFontSizeHeadingS: '14px',
    weetTypographyFontSizeHeadingXl: '20px',
    weetTypographyFontSizeHeadingXs: '13px',
    weetTypographyFontSizeHeadingXxl: '24px',
    weetTypographyFontSizeHeadingXxs: '12px',
    weetTypographyFontSizeHeadingXxxl: '32px',
    weetTypographyFontWeightBodyRegular: '400',
    weetTypographyFontWeightBodySemibold: '500',
    weetTypographyFontWeightHeadingBold: '600',
    weetTypographyFontWeightHeadingRegular: '400',
    weetTypographyFontWeightHeadingSemibold: '500',
    weetTypographyLineHeightBodyL: '24px',
    weetTypographyLineHeightBodyM: '22px',
    weetTypographyLineHeightBodyS: '20px',
    weetTypographyLineHeightBodyXs: '20px',
    weetTypographyLineHeightHeadingL: '26px',
    weetTypographyLineHeightHeadingM: '24px',
    weetTypographyLineHeightHeadingS: '22px',
    weetTypographyLineHeightHeadingXl: '28px',
    weetTypographyLineHeightHeadingXs: '20px',
    weetTypographyLineHeightHeadingXxl: '36px',
    weetTypographyLineHeightHeadingXxs: '20px',
    weetTypographyLineHeightHeadingXxxl: '48px'
};
export { tokens };
